(function() {
  "use strict";

  angular.module("PrintixMainMenu", [])

    .constant("PrintixMenuConstantsURLS", {
      MENU_MAIN_ITEMS: "assets/jsonFiles/menu/mainMenuItems.json"
    })

    .constant("PrintixMainMenuSelectors", {
      MAIN_MENU_CLASS_SELECTOR: "main-menu-parent",
      LANGUAGE_LIST_ITEM_CLASS_SELECTOR: "language-menu-parent"
    })

    .constant("RequiredMenuItemProperties", ["show", "icon", "testKey", "isSeparator", "key", "key.content", "key.allCapital",
      "value", "value.expression", "value.content", "value.allCapital", "clickFunction", "goToUrl"
    ])

    .controller("MainMenuController", ["$rootScope", "$scope", "$filter", "$location", "Utils", "$http",
      "PrintixMenuConstantsURLS", "RequiredMenuItemProperties", "$parse", "PrintixMainMenuSelectors",
      function($rootScope, $scope, $filter, $location, Utils, $http, PrintixMenuConstantsURLS, RequiredMenuItemProperties,
        $parse, PrintixMainMenuSelectors) {

        $scope.mainMenuItems = [];
        $scope.mainMenuClassSelector = PrintixMainMenuSelectors.MAIN_MENU_CLASS_SELECTOR;
        $scope.languageListItemClassSelector = PrintixMainMenuSelectors.LANGUAGE_LIST_ITEM_CLASS_SELECTOR;

        $scope.getCurrentUrl = function() {
          return $location.path();
        };

        $scope.menuItemClicked = function($event, menuItem) {
          if (menuItem) {
            if (menuItem.isLanguageMenuToggle) {
              $event.stopPropagation();
              $event.preventDefault();
              angular.element('.' + $scope.languageListItemClassSelector).addClass("open");
              Utils.adjustMenuDropDowns();
            } else {
              if (menuItem.clickFunction && !angular.isFunction(menuItem.clickFunction)) {
                $parse(menuItem.clickFunction)($rootScope)();
              }
            }
          } else {
            throw "$scope.menuItemClicked: menuItem is missing";
          }
        };

        $scope.refreshMenuItemExpressionResult = function(menuItem) {
          if (menuItem) {
            if (typeof menuItem.show !== "boolean") {
              menuItem.showResult = Utils.evalJs(menuItem.show);
            } else {
              menuItem.showResult = angular.copy(menuItem.show);
            }
            if (menuItem.alternativeActiveFunction) {
              menuItem.alternativeActive = Utils.evalJs(menuItem.alternativeActiveFunction);
            }
            if (menuItem.value.expression) {
              menuItem.value.expressionResult = Utils.evalJs(menuItem.value.expression);
            } else {
              menuItem.value.expressionResult = angular.copy(menuItem.value.content);
            }
          } else {
            throw "$scope.refreshMenuItemExpressionResult: menuItem is missing";
          }
        };

        $scope.addMenuItemToMainMenuItemsSuccessCallback = function(response) {
          $scope.mainMenuItems = [];
          angular.forEach(response.data, function(menuItem) {
            if (Utils.objectPropertiesCheck(menuItem, RequiredMenuItemProperties)) {
              $scope.refreshMenuItemExpressionResult(menuItem);
              $scope.mainMenuItems.add(menuItem);
            } else {
              console.error("$scope.addMenuItemToMainMenuItemsSuccessCallback: menuItem is invalid object");
              console.log(menuItem);
            }
          });
        };

        $rootScope.refreshMenuItemsExpressionResult = function() {
          angular.forEach($scope.mainMenuItems, function(menuItem) {
            $scope.refreshMenuItemExpressionResult(menuItem);
          });
        };

        $scope.getMenuItems = function() {
          $http.get(PrintixMenuConstantsURLS.MENU_MAIN_ITEMS, {
            cache: true
          }).then($scope.addMenuItemToMainMenuItemsSuccessCallback);
        };

        //Function triggers
        if (!$scope.mainMenuItems || $scope.mainMenuItems.length < 1) {
          $scope.getMenuItems();
        }
      }
    ])

    .directive("hideMenus", function() {
      return {
        link: function($scope, element, attrs) {
          element.on("click", function(event) {
            angular.element('.' + $scope.languageListItemClassSelector).removeClass("open");
            angular.element('.' + $scope.mainMenuClassSelector).removeClass("open");
            event.stopPropagation();
          });

          angular.element('.' + $scope.mainMenuClassSelector).on("hide.bs.dropdown", function() {
            angular.element('.' + $scope.languageListItemClassSelector).removeClass("open");
          });
        }
      };
    });
})();